<template>
  <div class="app-container pull-auto">
    <avue-crud ref="cityList" :page="page" :data="tableData" :table-loading="tableLoading" :option="tableOption"
      @current-change="currentChange" @refresh-change="refreshChange" @size-change="sizeChange" @row-click="rowcitySelect"
      @select="rowcitySelect">
      <template slot="search">
        <el-form-item label="省份">
          <el-select v-model="province" placeholder="请选择省份" @change="getProvince" clearable>
           <el-option v-for="item in form.provinces" :key="item.code" :label="item.name" :value="item.code">{{item.name}}</el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot-scope="scope" slot="menuLeft">
        <el-button class="filter-item" size="mini" type="primary" @click="edit" icon="el-icon-edit" :disabled="isSelect">修改
        </el-button>
      </template>
    </avue-crud>

    <el-dialog title="修改工种价格" :visible.sync="editDlg">
     <div v-for="item in reSelectCityList" :key="item.provinceCode">
        <div class="city-list">
          <div style="padding-right: 100px;">省份 : {{item.provinceName}}</div>
          <div>
            <span>城市 : </span>
            <span  v-if="item.cityName.length&&item.cityName.length>0" v-for="(citem,index) in (item.cityName)" :key="index">{{citem}}</span>
            <span v-else>{{item.cityName}}</span>
          </div>
        </div>
      </div>
      <div v-for="(witem,windex) in workerPriceMappings" :key="windex">
        <div class="city-list list-price">
          <div class="min-w">{{workerPriceMappings[windex].workerTypeName}}</div>
          <el-input  placeholder="请输入价格" v-model="prices[windex]"></el-input>
          <div class="min-w pl-10">人天</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer p-38">
        <el-button @click="editDlg=false">取消</el-button>
        <el-button @click="cityListComfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getAllProvince,
    predictPrice,
    updatePriceForIds,
    getWorkerPriceMappings
  } from '@/api/admin/estimate'
  import {
    objKeySort
  } from '@/util/ajaxsign'
  export default {
    data() {
      return {
        witemsetPrice:'',
        tableData: [],
        isSelect: true,
        province:'',
        provinceCode:'',
        form:{
          provinces:  []
        },
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 10 // 每页显示多少条
        },
        listQuery: {
          current: 1,
          size: 10
        },
        selectCityList:[],//已选择的城市
        reSelectCityList:[],//重组已选城市
        editDlg:false,
        tableLoading: false,
        workerPriceMappings:[],//column 字段
        prices:[0,0,0,0,0,0,0,0],
        tableOption: {
          addBtn: false,
          border: true,
          index: true,
          stripe: true,
          indexLabel: " ",
          menu: false,
          align: 'center',
          refreshBtn: false,
          searchBtn: false,
          selection:true,
          column: [
            {
              label: '省份',
              prop: 'provinceName'
            },
            {
              label: '城市',
              prop: 'cityName'
            }
          ]
        }
      }
    },
    created() {
      this.getWorkerPriceMappings()
      this.getList()
      this.predictPrice()
    },
    mounted: function() {},
    computed: {},
    methods: {
      getList() {
        let that=this
        let mdata = {}
        getAllProvince(objKeySort(mdata)).then(response => {
          if(response.status==200&&response.data.data){
            that.form.provinces = response.data.data
          }
        })
      },
      getWorkerPriceMappings() {
        let that=this
        //获取 平台预估价工种映射关系对应
        getWorkerPriceMappings(objKeySort()).then(response => {
          if(response.status==200&&response.data.data){
            that.workerPriceMappings = response.data.data
            that.workerPriceMappings.forEach(item=>{
              that.tableOption.column.push({
                label:item.workerTypeName+'(人天)',
                prop:item.priceColumn
              });
            })
          }
        })
      },
      //获取 平台预估价列表
      predictPrice() {
        let that=this
        let mdata = {
          pageNum:that.page.currentPage,
          pageSize:that.page.pageSize,
          pcode:that.provinceCode,
        }
        that.tableLoading = true
        predictPrice(objKeySort(mdata)).then(obj => {
          if(obj.status==200&&obj.data.data){
            that.tableLoading = false
            obj.data.data.rows.forEach(item=>{
              item.check=false
            })
            that.tableData = obj.data.data.rows
            that.page.total = obj.data.data.total
          }
        })
      },
      //改变选择则后 省份code 赋值
      getProvince(e) {
        let that=this
        that.provinceCode = e
        that.predictPrice()
      },
      handleAdd() {},
      currentChange(val) {
        let that=this
        that.page.currentPage = val
        that.predictPrice()
      },
      sizeChange(val) {
        let that=this
        that.page.pageSize = val
        that.predictPrice()
      },
      isDisable(arr){
        let that=this
        if(arr.length>0){
          that.isSelect=false
        }else{
          that.isSelect=true
        }
      },
      rowcitySelect(val) {
        let that=this
        if(Object.prototype.toString.call(val)== '[object Array]'){
          that.selectCityList = val;
          that.isDisable(that.selectCityList)
        }else{
          // 有勾选的数据
          if(that.selectCityList.length>0){
            // 遍历并判断是否是选择了 已在选择数据中的数据
            that.selectCityList.slice().reverse().forEach((citem, index, object)=>{
              if(citem.id==val.id){
                // 取消已经勾选的
                that.selectCityList.splice(object.length - 1 - index, 1);
                that.isDisable(that.selectCityList)
                // citem.check=false
                that.$nextTick(() => {
                    that.$refs.cityList.toggleRowSelection(val, false);
                });
              }
            })
          }
          if(that.tableData.length>0){
            that.tableData.forEach(item=>{
              if(item.id==val.id&&item.check==true){
                 item.check=false
                 that.isDisable(that.selectCityList)
                 that.$nextTick(() => {
                   that.$refs.cityList.toggleRowSelection(item, false);
                 })
              }else if((val.check==undefined||val.check==false)&&item.id==val.id){
                item.check=true
                that.selectCityList.push(item)
                that.isSelect=false
                that.$nextTick(() => {
                  that.$refs.cityList.toggleRowSelection(item, true);
                })
              }
            })
          }
        }
      },
      // 确定选择
      cityListComfirm() {
       let that=this
       let _ids=''
       that.reSelectCityList.forEach(item=>{
         if(Object.prototype.toString.call(item.id)== '[object Array]'){
           item.id.forEach(citem=>{
             if(_ids==''){
              _ids=citem
             }else{
               if((citem+'').slice(0,1) == ","){
                _ids+=citem
               }else{
                 _ids+=','+citem
               }
             }
           })
         }else{
           _ids=item.id
         }
       })

       let ppp = ['','','','','','','',''];
       for(let i=0;i<that.workerPriceMappings.length;i++){
         let n = that.workerPriceMappings[i].priceColumn.slice(5,6);
         ppp[parseInt(n)-1]=that.prices[i];
       }

       let mdata={
         ids:_ids+'',
         price1:ppp[0],
         price2:ppp[1],
         price3:ppp[2],
         price4:ppp[3],
         price5:ppp[4],
         price6:ppp[5],
         price7:ppp[6],
         price8:ppp[7]
       }

       that.tableLoading = true;
       updatePriceForIds(objKeySort(mdata)).then(obj => {
          if(obj.status==200&&obj.data.data){
            that.$message({
              message: '修改成功',
              type: 'success'
            });
            that.tableLoading = false
            that.editDlg=false;
            that.selectCityList.length=0;
            that.$nextTick(() => {
              that.$refs.cityList.clearValidate();
            })
            that.isSelect=true;
            that.refreshChange();
          }
        })
      },
      mergeObject(array) {
       return array=array.map(function(item,index,array){
           const i=array.find(_item=>item.provinceName===_item.provinceName);
            if(i!==item){
                i.cityName.push(","+item.cityName);
                i.id.push(","+item.id);
                return undefined;
            }else{
                i.cityName=[i.cityName];
                i.id=[i.id];
                return i;
            }
        }).filter(item=>item!==undefined);
      },
      // 选择后修改
      edit() {
        let that=this
        let _reSelectCityList=[]
        _reSelectCityList = JSON.parse(JSON.stringify(that.selectCityList));
        that.reSelectCityList=that.mergeObject(_reSelectCityList);
        console.log(that.selectCityList);
        for(let i=0;i<that.workerPriceMappings.length;i++){
          that.prices[i]=that.selectCityList[0][that.workerPriceMappings[i].priceColumn];
        }
        that.editDlg=true;
      },

      /**
       * 刷新回调
       */
      refreshChange() {
        let that=this;
        that.provinceCode = '';
        that.predictPrice();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .avue-crud /deep/ .avue-crud__menu {
    margin-bottom: 0px !important;
  }
  .city-list{
    display: flex;
    align-items: center;
    padding-left: 20px;
    margin-bottom: 15px;
  }
  .list-price{
    padding: 0 50px;
  }
  .min-w{
    min-width: 55px;
  }
  .pull-auto .avue-crud /deep/ .el-form-item__content .el-button {
    display: none;
  }
  .pull-auto .avue-crud /deep/ .avue-crud__tip {
    display: none;
  }
  .pl-10{padding-left: 10px;}
</style>
